export function compareCurrency(a, b) {
  const toNumber = (value) => {
    if (!value || typeof value !== "string") return 0;

    // Odstranit mezery, měnu a nahradit čárku tečkou pro správný parseFloat
    const cleaned = value
      .replace(/[^\d,-]/g, "") // odstraní všechno kromě číslic, čárky a pomlčky
      .replace(",", "."); // CZ čárka na desetinnou tečku

    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  };

  return toNumber(a) - toNumber(b);
}

export function formatCurrency(value) {
  const number = Number(value);
  if (isNaN(number)) return "-";

  return new Intl.NumberFormat("cs-CZ", {
    style: "currency",
    currency: "CZK",
  }).format(number);
}
